const loading = () => import('./loading/loading')
const share = () => import('./share')
const importTemplate = () => import('./importTemplate')
const selfVideoPlayer = () => import('./selfVideoPlayer')
const maxHeightLimit = () => import('./maxHeightLimit')
const customerPopup = () => import('./customerPopup')
const seize = () => import('./seize.vue')

const components = {
    loading,
    share,
    importTemplate,
    selfVideoPlayer,
    maxHeightLimit,
    customerPopup,
    seize
} 
export default {
    install (vue, b, c) {
        this.addComponents(vue)
    },
    addComponents (vue) {
        for(let i in components) {
            vue.component(i, components[i]);
        }
    }
}